//require("bootstrap/dist/css/bootstrap.min.css");
require("../css/base.css");
require("../css/styles.css");
require("../css/fonts.css");

// Register Service Worker (lazy loaded after page load)
// DISABLED: Service worker registration commented out
// if ("serviceWorker" in navigator) {
//   // Use requestIdleCallback for non-critical service worker registration
//   if (window.requestIdleCallback) {
//     requestIdleCallback(() => {
//       navigator.serviceWorker
//         .register("/sw.js")
//         .then((registration) => {
//           console.log(
//             "[Service Worker] Registered successfully:",
//             registration.scope
//           );
//         })
//         .catch((error) => {
//           console.log("[Service Worker] Registration failed:", error);
//         });
//     });
//   } else {
//     // Fallback for browsers without requestIdleCallback
//     window.addEventListener("load", () => {
//       setTimeout(() => {
//         navigator.serviceWorker
//           .register("/sw.js")
//           .then((registration) => {
//             console.log(
//               "[Service Worker] Registered successfully:",
//               registration.scope
//             );
//           })
//           .catch((error) => {
//             console.log("[Service Worker] Registration failed:", error);
//           });
//       }, 1000);
//     });
//   }
// }

document.addEventListener("DOMContentLoaded", () => {
  // Check if running on localhost, local IP, or dev environment
  const isLocalEnvironment =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "0.0.0.0" ||
    window.location.hostname === "" ||
    window.location.hostname === "mello-lidl-se.dev.mh.schwarz" ||
    window.location.hostname === "gnista.availsthlm.se" ||
    window.location.protocol === "file:";

  if (isLocalEnvironment) {
    // Load YouTube API directly for local environments
    if (!window.YT) {
      console.log("Loading YouTube API for local environment");
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      loadYouTubePlayer();
    }
  } else {
    // Ensure OneTrust is fully loaded for production
    if (typeof OnetrustActiveGroups !== "undefined") {
      handleMarketingCookieConsent();
    }
  }
});

window.onload = function () {
  var body = document.getElementsByTagName("body");
  body[0].style.removeProperty("background");

  var wrapper = document.getElementById("wrapper");
  if (wrapper) {
    wrapper.style.opacity = "1";
  }

  // Initialize parallax effect
  initParallax();
};

// Parallax effect for hero section
function initParallax() {
  const hero = document.getElementById("mello-hero");
  const heroContent = hero?.querySelector(".hero-content");
  console.log(heroContent);
  if (!hero) return;

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) {
    return; // Disable parallax for users who prefer reduced motion
  }

  let ticking = false;

  function updateParallax() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const heroHeight = hero.offsetHeight;
    const heroTop = hero.offsetTop;
    const heroBottom = heroTop + heroHeight;

    // Only apply parallax when hero is in viewport
    if (scrollTop < heroBottom && scrollTop + window.innerHeight > heroTop) {
      // Calculate how much we've scrolled relative to hero section
      const scrollWithinHero = Math.max(0, scrollTop - heroTop);

      // Parallax speed factors (lower = slower movement, creates depth)
      const backgroundSpeed = 0.05; // Background moves at 5% of scroll speed
      // Calculate transform values based on scroll within hero
      const backgroundOffset = scrollWithinHero * backgroundSpeed;

      // Apply transforms - background moves slower creating parallax depth
      hero.style.backgroundPosition = `center ${50 + backgroundOffset * 0.15}%`;
      
     /* if (heroContent) {
        // Check if mobile/tablet (centered with translateX below 992px)
        const isMobile = window.innerWidth < 992;
        if (isMobile) {
          heroContent.style.transform = `translateX(-50%) translateY(${contentOffset}px)`;
        } else {
          heroContent.style.transform = `translateY(${contentOffset}px)`;
        }
      }*/

     
    } else {
      // Reset transforms when hero is out of view
      hero.style.backgroundPosition = "center center";
     /* if (heroContent) {
        // Check if mobile/tablet (centered with translateX below 992px)
        const isMobile = window.innerWidth < 992;
        if (isMobile) {
          heroContent.style.transform = "translateX(-50%) translateY(0)";
        } else {
          heroContent.style.transform = "translateY(0)";
        }
      }*/
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  // Use passive event listener for better performance
  window.addEventListener("scroll", requestTick, { passive: true });
  window.addEventListener("resize", requestTick, { passive: true });

  // Initial call
  updateParallax();
}

function handleMarketingCookieConsent() {
  if (
    window.location.hostname === "localhost" ||
    OnetrustActiveGroups.includes("C0004")
  ) {
    // Lazy load YouTube player when consent is given
    loadYouTubePlayer();
  }
}

window.addEventListener("OneTrustGroupsUpdated", () => {
  handleMarketingCookieConsent();
});

// Lazy load YouTube player code
let youtubePlayerLoaded = false;

function loadYouTubePlayer() {
  if (youtubePlayerLoaded) return;
  youtubePlayerLoaded = true;

  import("../js/youtube-player.js").catch((error) => {
    console.error("Error loading YouTube player module:", error);
    youtubePlayerLoaded = false; // Allow retry on error
  });
}

// Set up callback for when YouTube API is ready
window.onYouTubeIframeAPIReady = function () {
  console.log("YouTube API ready, loading player module");
  // Lazy load the player module when API is ready
  loadYouTubePlayer();
};

// Fallback: If running locally and YouTube API hasn't loaded after a delay, try loading it
setTimeout(function () {
  const isLocalEnvironment =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "0.0.0.0" ||
    window.location.hostname === "" ||
    window.location.hostname === "matriket-lidl-se.dev.mh.schwarz" ||
    window.location.hostname === "godjul.availsthlm.se" ||
    window.location.protocol === "file:";

  if (isLocalEnvironment && typeof window.YT === "undefined") {
    // Check if script tag already exists
    var existingScript = document.querySelector(
      'script[src*="youtube.com/iframe_api"]'
    );
    if (!existingScript) {
      console.log("Fallback: Loading YouTube API after timeout");
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
}, 1000);

window.OptanonWrapper = function () {
  console.log("OptanonWrapper called");
  // Check if running on localhost, local IP, or dev environment
  const isLocalEnvironment =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "0.0.0.0" ||
    window.location.hostname === "" ||
    window.location.hostname === "scenenardin-lidl-se.dev.mh.schwarz" ||
    window.location.hostname === "gnista.availsthlm.se" ||
    window.location.protocol === "file:";

  if (isLocalEnvironment) {
    // Manually load YouTube API script on localhost or dev environment
    if (!window.YT) {
      console.log("Loading YouTube API on dev/local");
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      // If YT is already loaded, load the player module
      console.log("YouTube API already loaded, loading player module");
      loadYouTubePlayer();
    }
  } else {
    // Try OneTrust first, but fallback to direct load if not available
    if (typeof OneTrust !== "undefined" && OneTrust.InsertScript) {
      console.log("Loading YouTube API through OneTrust");
      OneTrust.InsertScript(
        "https://www.youtube.com/iframe_api",
        "head",
        null,
        null,
        "C0004"
      );
    } else {
      // Fallback: load YouTube API directly if OneTrust is not available
      console.log("OneTrust not available, loading YouTube API directly");
      if (!window.YT) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        loadYouTubePlayer();
      }
    }
  }
};
